import React, { useEffect, useRef } from "react";

interface ReviewsIoWidgetProps {
  html: string;
}

const ReviewsIoWidgetv2 = ({ html, ...props }: ReviewsIoWidgetProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    // Parse incoming HTML string
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // --- 1. Inject CSS ---
    doc.querySelectorAll("link").forEach((link) => {
      if (!document.querySelector(`link[href="${link.href}"]`)) {
        document.head.appendChild(link.cloneNode(true));
      }
    });

    // --- 2. Add widget container (div) ---
    const divs = doc.querySelectorAll("div[id]");
    if (divs.length > 0 && containerRef.current) {
      containerRef.current.innerHTML = "";
      divs.forEach((d) => {
        containerRef.current?.appendChild(d.cloneNode(true));
      });
    }

    // --- 3. Separate scripts ---
    const externalScripts: string[] = [];
    const inlineScripts: string[] = [];

    doc.querySelectorAll("script").forEach((s) => {
      if (s.src) {
        externalScripts.push(s.src);
      } else if (s.innerHTML.trim()) {
        inlineScripts.push(s.innerHTML);
      }
    });

    // --- 4. Loader for external JS ---
    const loadScript = (src: string) =>
      new Promise<void>((resolve) => {
        if (document.querySelector(`script[src="${src}"]`)) {
          resolve();
        } else {
          const script = document.createElement("script");
          script.src = src;
          script.async = true;
          script.onload = () => resolve();
          document.body.appendChild(script);
        }
      });

    // --- 5. Load in order ---
    (async () => {
      for (const src of externalScripts) {
        await loadScript(src);
      }
      // after externals loaded, run inline initializers
      inlineScripts.forEach((code) => {
        try {
          // Safer than appending <script>, execute directly
          // eslint-disable-next-line no-eval
          eval(code);
        } catch (e) {
          console.error("Failed to run Reviews.io inline script", e);
        }
      });
    })();

    // --- 6. Cleanup on unmount ---
    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = "";
      }
    };
  }, [html]);

  return <div {...props} ref={containerRef} />;
};

export default ReviewsIoWidgetv2;